import { render, staticRenderFns } from "./CThresholdsStock.vue?vue&type=template&id=73319a6b&scoped=true"
import script from "./CThresholdsStock.vue?vue&type=script&lang=js"
export * from "./CThresholdsStock.vue?vue&type=script&lang=js"
import style0 from "./CThresholdsStock.vue?vue&type=style&index=0&id=73319a6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73319a6b",
  null
  
)

export default component.exports